<template>
  <div class="tags-view">
    <div
      v-for="tag in visitedViews"
      :key="tag.fullPath"
      :class="['tags-view-item', isActive(tag) ? 'active' : '']"
      @click="toTag(tag)"
    >
      <span>{{ tag.title }}</span>
      <i
        v-if="!tag.affix"
        class="el-icon-close"
        @click.stop="closeTag(tag)"
      ></i>
    </div>
  </div>
</template>

<script>
export default {
  name: "TagsView",
  data() {
    return {
      visitedViews: []
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        this.addView(route);
      }
    }
  },
  methods: {
    isActive(tag) {
      return tag.fullPath === this.$route.fullPath;
    },
    addView(route) {
      if (!route || route.path === "/" || route.name === "login") return;
      const title = (route.meta && route.meta.title) || route.name || "未命名";
      const exists = this.visitedViews.some(v => v.fullPath === route.fullPath);
      if (exists) return;
      this.visitedViews.push({
        title,
        path: route.path,
        fullPath: route.fullPath,
        query: route.query,
        name: route.name,
        affix: !!(route.meta && route.meta.affix)
      });
    },
    toTag(tag) {
      if (tag.fullPath !== this.$route.fullPath) {
        this.$router.push(tag.fullPath);
      }
    },
    closeTag(tag) {
      const index = this.visitedViews.findIndex(v => v.fullPath === tag.fullPath);
      if (index < 0) return;
      const isActive = this.isActive(tag);
      this.visitedViews.splice(index, 1);
      if (!isActive) return;
      const next = this.visitedViews[index] || this.visitedViews[index - 1];
      if (next) {
        this.$router.push(next.fullPath);
      } else {
        this.$router.push("/dashboard/index");
      }
    }
  }
};
</script>

<style scoped lang="scss">
.tags-view {
  display: flex;
  align-items: center;
  height: 40px;
  margin: 8px 10px 0;
  padding: 0 8px;
  background: #fff;
  border-radius: 4px;
  overflow-x: auto;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

.tags-view-item {
  display: inline-flex;
  align-items: center;
  height: 26px;
  padding: 0 8px;
  margin-right: 6px;
  font-size: 12px;
  color: #495060;
  background: #fff;
  border: 1px solid #d8dce5;
  border-radius: 2px;
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    color: #007EFF;
  }

  &.active {
    color: #fff;
    background: #007EFF;
    border-color: #007EFF;

    .el-icon-close {
      color: #fff;
    }
  }

  .el-icon-close {
    margin-left: 6px;
    width: 14px;
    height: 14px;
    line-height: 14px;
    border-radius: 50%;
    text-align: center;

    &:hover {
      background: rgba(0, 0, 0, 0.15);
      color: #fff;
    }
  }
}
</style>
